import { useState, useEffect } from 'react';

//import styling + main js
import './App.scss';

//import components
import Header from './components/Header';
import Footer from './components/Footer';
import Content from './components/Content';


function App() {

  //GLOBAL STATE
  const initialDestinationState = {
    lang: '',
    dest: ''
  };

  const [destinationState, setDestinationState] = useState(initialDestinationState);

  useEffect(() => {
    //set state lang + destination
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let tempLang = params.lang === 'fr' ? 'fr' : 'en'; //!! ALWAYS SET THE LANGUAGE TO 'EN', IF IT'S NOT 'FR' (avoids lang errors!)

    setDestinationState({
      lang: tempLang,
      dest: params.dest
    });

    //change the title according to the lang
    if(params.lang === 'fr'){
      document.title = "Nouvelles destinations | Porter Airlines";
      document.documentElement.lang = "fr";
    } else {
      document.title = "New Destinations | Porter Airlines";
      document.documentElement.lang = "en";
    }

  }, []);



  return (
    <div className="app">
      {/* {console.log(destinationState.lang, destinationState.dest)} */}
      <Header />
        <Content lang={destinationState.lang} dest={destinationState.dest} />
      <Footer />
    </div>
  );
}

export default App;




// OLD HOMEPAGE NAV FUNCTION (sits above return)
// function for homepage nav
// const updatePageContentHandler = (event) =>{  
//   let currentPath = window.location.pathname; //get the main path (minus the params - after "?")
//   let newLang = destinationState.lang; //get the current lang (from state)
//   let newDest = event.target.getAttribute('which_dest'); //get the new destination from the button clicked
  
//   window.history.pushState("", "", `${currentPath}?lang=${newLang}&dest=${newDest}`); //update the url with new params
  
//   //update the state with the lang and dest values
//   setDestinationState({
//     lang: newLang,
//     dest: newDest
//   });
// }